import { createBrowserRouter, Navigate } from 'react-router-dom'
import { AppLayout }  from '@/components/layout/AppLayout'
import { AuthLayout } from '@/components/layout/AuthLayout'
import { AdminLayout } from '@/components/layout/AdminLayout'

// ── Auth Pages ──
import { LoginPage }    from '@/pages/auth/LoginPage'
import { RegisterPage } from '@/pages/auth/RegisterPage'

// ── App Pages ──
import { GlobalDashboardPage }    from '@/pages/GlobalDashboardPage'
import { BusinessListPage }        from '@/pages/businesses/BusinessListPage'
import { BusinessNewPage }         from '@/pages/businesses/BusinessNewPage'
import { BusinessDetailPage }      from '@/pages/businesses/BusinessDetailPage'
import { CapitalPage }             from '@/pages/businesses/CapitalPage'
import { ProductsPage }            from '@/pages/businesses/ProductsPage'
import { CostsPage }               from '@/pages/businesses/CostsPage'
import { SimulationsPage }         from '@/pages/businesses/SimulationsPage'
import { SimulationDetailPage }    from '@/pages/businesses/SimulationDetailPage'
import { DashboardPage }         from '@/pages/businesses/DashboardPage'
import { ReportsPage }             from '@/pages/businesses/ReportsPage'
import { ReportViewerPage }        from '@/pages/businesses/ReportViewerPage'
import { DocumentsPage }           from '@/pages/businesses/DocumentsPage'
import { ActualsPage }             from '@/pages/businesses/ActualsPage'
import { ActualComparisonPage }    from '@/pages/businesses/ActualComparisonPage'
import { SettingsPage }            from '@/pages/SettingsPage'
import { NotFoundPage }            from '@/pages/NotFoundPage'

// ── Admin Pages ──
import { AdminOverviewPage }   from '@/pages/admin/AdminOverviewPage'
import { AdminUsersPage }      from '@/pages/admin/AdminUsersPage'
import { AdminBusinessesPage } from '@/pages/admin/AdminBusinessesPage'
import { AdminAuditLogsPage }  from '@/pages/admin/AdminAuditLogsPage'

export const router = createBrowserRouter([
  // ── Auth routes (no sidebar) ─────────────────────────────────────────────
  {
    element: <AuthLayout />,
    children: [
      { path: '/login',    element: <LoginPage />    },
      { path: '/register', element: <RegisterPage /> },
    ],
  },

  // ── App routes (with sidebar) ─────────────────────────────────────────────
  {
    element: <AppLayout />,
    children: [
      // Root → redirect to dashboard
      { index: true, element: <Navigate to="/dashboard" replace /> },

      // Global
      { path: '/dashboard',   element: <GlobalDashboardPage /> },
      { path: '/settings',    element: <SettingsPage />        },

      // Business list & creation
      { path: '/businesses',     element: <BusinessListPage /> },
      { path: '/businesses/new', element: <BusinessNewPage />  },

      // Business detail & sub-pages
      // NOTE: /businesses/new must come before :businessId to avoid route conflict
      { path: '/businesses/:businessId',                           element: <BusinessDetailPage />    },
      { path: '/businesses/:businessId/capital',                   element: <CapitalPage />           },
      { path: '/businesses/:businessId/products',                  element: <ProductsPage />          },
      { path: '/businesses/:businessId/costs',                     element: <CostsPage />             },
      { path: '/businesses/:businessId/simulations',               element: <SimulationsPage />       },
      { path: '/businesses/:businessId/simulations/:simulationId', element: <SimulationDetailPage />  },
      { path: '/businesses/:businessId/dashboard',                 element: <DashboardPage />         },
      { path: '/businesses/:businessId/actuals',                   element: <ActualsPage />           },
      { path: '/businesses/:businessId/actuals/compare',           element: <ActualComparisonPage />  },
      { path: '/businesses/:businessId/reports',                   element: <ReportsPage />           },
      { path: '/businesses/:businessId/reports/:reportType',       element: <ReportViewerPage />      },
      { path: '/businesses/:businessId/documents',                 element: <DocumentsPage />         },
    ],
  },

  // ── Admin routes (with admin sidebar) ───────────────────────────────────
  {
    element: <AdminLayout />,
    children: [
      { path: '/admin',             element: <AdminOverviewPage /> },
      { path: '/admin/users',       element: <AdminUsersPage /> },
      { path: '/admin/businesses',  element: <AdminBusinessesPage /> },
      { path: '/admin/audit-logs',  element: <AdminAuditLogsPage /> },
      { path: '/admin/settings',    element: <div className="text-white">Settings Coming Soon</div> },
    ],
  },

  // ── 404 ──────────────────────────────────────────────────────────────────
  { path: '*', element: <NotFoundPage /> },
])
